export const VIEWS = {
  READER: "READER",
  HIGHLIGHTS: "HIGHLIGHTS"
};

export const PANEL_MODES = {
  HIGHLIGHTS: "highlights",
  ANSWER: "answer"
};
